import {CampaignDTO, StatsUpdateEventDTO} from "./types";

export function setupTotal(campaign: CampaignDTO) {
    return {
        total_signatures: campaign.petition.total_signatures,
        duration: campaign.ui.animate_progress_time,
        animateValue(htmlElement: HTMLElement, start: number, end: number, duration: number) {
            let startTimestamp = null;
            const step = (timestamp: number) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                const integerFormat = new Intl.NumberFormat();
                htmlElement.innerHTML = integerFormat.format(Math.floor(progress * (end - start) + start));
                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        },
        init() {
            const total_elm = document.getElementById('total_signatures');
            if (this.total_signatures > 1) {
                this.animateValue(total_elm, 1, this.total_signatures, this.duration);
            }
            document.addEventListener('stats.update', (e: CustomEventInit<StatsUpdateEventDTO>) => {
                if (e.detail.total_signatures > this.total_signatures) {
                    this.animateValue(total_elm, this.total_signatures, e.detail.total_signatures, this.duration);
                    this.total_signatures = e.detail.total_signatures;
                }
            });
        },
    };
}
